import React from 'react';
import { css } from 'emotion';
import Header from '../common/Header';
export default (function () {
  return React.createElement(Header, {
    className: headerCls
  });
});
var headerCls = /*#__PURE__*/css("padding:0;#title{margin-top:60px;font-size:36px;line-height:1.5;font-weight:400;letter-spacing:0.2px;margin-bottom:24px;}#description{margin-top:24px;font-size:14px;line-height:1.5;letter-spacing:0.2px;color:var(--text-color-secondary);font-weight:350;font-stretch:normal;font-style:normal;margin-bottom:60px;}");